import { sleep } from 'web-utility';
import { IReactionDisposer, observable, reaction } from 'mobx';
import { observer } from 'mobx-react';
import { PropsWithChildren, PureComponent } from 'react';
import { Row, Col, Modal, ModalProps } from 'react-bootstrap';

import classNames from 'classnames';
import * as styles from './index.module.less';
import { WalletType } from '../../model/utils/connector';
import session from '../../model/Session';

export type ChooseWalletProps = PropsWithChildren<Pick<ModalProps, 'onHide'>>;

@observer
export class ChooseWallet extends PureComponent<ChooseWalletProps> {
  @observable
  show = false;

  @observable
  connecting = false;

  @observable
  modalTitle = 'Choose your wallet';

  private autoDisposer?: IReactionDisposer;

  componentDidMount() {
    this.resetState();
    this.autoDisposer = reaction(
      () => session.isConnected,
      v => v && this.onHide()
    );
  }

  resetState = () => {
    this.show = false;
    this.connecting = false;
    this.modalTitle = 'Connect your wallet';
  };

  onHide = async () => {
    this.props.onHide?.();

    await sleep(0.5);

    this.resetState();
  };

  tryAgain = () => {
    this.connecting = false;
    this.modalTitle = 'Connect your wallet';
  };

  handleConnect = async (walletType: WalletType) => {
    this.connecting = true;
    this.modalTitle = 'Connecting...';

    try {
      await session.connectWallet(walletType);
    } catch (error) {
      console.error(error);
    }
  };

  componentWillUnmount = () => {
    if (this.autoDisposer) this.autoDisposer();
  };

  renderConnecting() {
    return (
      <div className="d-flex align-items-center justify-content-center flex-column">
        <div className="p-5">
          <div className={styles['loading-border']}>
            <span className={styles['loading-text']}>Connecting</span>
          </div>
        </div>
        <div className="w-100 text-end">
          <button className={styles['btn-try-again']} onClick={this.tryAgain}>
            <i className={styles['icon-try-again']} />
            Try again
          </button>
        </div>
      </div>
    );
  }

  renderChooseWallet() {
    return (
      <Row>
        <Col xs="12" md="6">
          <button
            className={styles['btn-wallet']}
            onClick={() => this.handleConnect(WalletType.StoicWallet)}
          >
            <i
              className={classNames(
                styles['icon-wallet'],
                styles['icon-wallet-stoic']
              )}
            />
            Stoic Wallet
          </button>
        </Col>
        <Col xs="12" md="6">
          <button
            className={styles['btn-wallet']}
            onClick={() => this.handleConnect(WalletType.PlugWallet)}
          >
            <i
              className={classNames(
                styles['icon-wallet'],
                styles['icon-wallet-plug']
              )}
            />
            Plug Wallet
          </button>
        </Col>
        <Col xs="12" md="6">
          <button
            className={styles['btn-wallet']}
            onClick={() => this.handleConnect(WalletType.AstroX)}
          >
            <i
              className={classNames(
                styles['icon-wallet'],
                styles['icon-wallet-AstroX']
              )}
            />
            AstroX me
          </button>
        </Col>
        {/* <Col xs="12" md="6">
          <button
            className={styles['btn-wallet']}
            onClick={() => this.handleConnect(WalletType.InfinityWallet)}
          >
            <i
              className={classNames(
                styles['icon-wallet'],
                styles['icon-wallet-InfinityWallet']
              )}
            />
            Infinity Wallet
          </button>
        </Col>
        <Col xs="12" md="6">
          <button
            className={styles['btn-wallet']}
            onClick={() => this.handleConnect(WalletType.NFID)}
          >
            <i
              className={classNames(
                styles['icon-wallet'],
                styles['icon-wallet-NFID']
              )}
            />
            NFID
          </button>
        </Col> */}
      </Row>
    );
  }

  render() {
    const { children } = this.props,
      { show, modalTitle, onHide } = this;

    return (
      <div onClickCapture={() => !session.isConnected && (this.show = true)}>
        {children}

        {show && (
          <Modal centered show onHide={onHide}>
            <Modal.Header
              className={
                this.connecting ? styles['no-border'] : styles['has-border']
              }
            >
              <Modal.Title className={styles['modal-title']}>
                {modalTitle}
              </Modal.Title>
            </Modal.Header>
            <Modal.Body>
              {this.connecting
                ? this.renderConnecting()
                : this.renderChooseWallet()}
            </Modal.Body>
          </Modal>
        )}
      </div>
    );
  }
}
